<template>
  <div class="two-column-wrapper">
    <div class="data-body">
      <slot name="data-body"></slot>
    </div>
    <div class="data-details">
      <slot name="data-details"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TwoColumnLayout'
}
</script>

<style>
.two-column-wrapper {
  display: flex
}

.data-body {
  flex: 0 0 575px;
  border-right: 1px solid rgba(33, 33, 33, 0.08);
  height: calc(100vh - 64px); /* 64px because of the header height */
  overflow: auto !important;
}

.data-details {
  flex: 1;
}

/* For mobile screens */
@media only screen and (max-width: 561px) {
  .two-column-wrapper {
    display: block
  }

  .data-body {
    flex: 0 0 575px;
    border-right: 1px solid rgba(33, 33, 33, 0.08);
    display: flex;
    height: calc(100vh - 106px);
    flex-direction: column;
    justify-content: space-between;
  }

  .data-details {
    display: none
  }
}
</style>
